
export default {
  name: 'Texteditor',

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    blockStyle() {
      return {
        backgroundColor: this.data.bg_color || 'transparent',
        color: this.data.text_color || '#201f20',
      };
    },
  },
};
